/** Part C — Broker/ISO link resolution modal. */
import React, { useCallback } from 'react';
import { Handshake } from 'lucide-react';
import { LinkResolutionModal } from './ResolutionModalBase';

export default function BrokerLinkResolutionModal({ open, onOpenChange, deal, onResolved }) {
  const filter = useCallback((c) => !!c.is_broker || !!c.is_iso, []);
  return (
    <LinkResolutionModal
      open={open}
      onOpenChange={onOpenChange}
      deal={deal}
      title="Link Broker/ISO"
      description="Select an existing broker or ISO contact. Required to set commissions."
      icon={<Handshake className="h-4 w-4" />}
      fieldKey="broker_id"
      contactType="broker"
      contactFilter={filter}
      onResolved={onResolved}
      testidPrefix="resolve-broker-link"
    />
  );
}
